import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f6e2caa6")

_pushScopeId("data-v-f6e2caa6")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "pa-4" }
const _hoisted_3 = {
  class: "pa-4",
  style: {"color":"white"}
}
const _hoisted_4 = { class: "py-6 text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_my_card, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_3, _toDisplayString($props.name) + "邀请您绑定设备,绑定后您可以获取睡眠报告、查看助眠知识,参与睡眠优化计划等. ", 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: $props.url,
              style: {"width":"70vw","height":"70vw"}
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
})